import React from 'react';

import { CircularProgress } from '@material-ui/core';

// Don't use tailwind so styles can easily be overwritten:
const defaultStyles: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  margin: '1rem 0',
};

export default function LoadingSpinner({ style, ...props }: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {
  return (
    <div {...props} style={{ ...defaultStyles, ...style }}>
      <CircularProgress />
    </div>
  );
}
